module.exports = __webpack_public_path__ + "img/a1_1_E.2a80b8c9.jpg";